import React from "react";
import { css } from "@emotion/react";
import { Label, Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { COMPANY_OPTIONS_PREFECTURES } from "@/libs/constants";
import { FormErrorMessage, FormSelectBox } from "@/components/molecules";

type Props = {
  name: string;
  labelRequired: boolean;
};

export const PrefecturesFormField = (props: Props) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          都道府県 {props.labelRequired && <Label variant="required" />}
        </Font>
      </div>
      <div css={inputWrapper}>
        <FormSelectBox
          name={props.name}
          placeholder={"未選択"}
          options={COMPANY_OPTIONS_PREFECTURES}
          registerOptions={{
            required: "選択してください",
          }}
        />
        <FormErrorMessage name={props.name} />
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "196px",
});
